import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { AuthVerifyYourEmail } from "@/components/features/auth/verify-your-email";

export const AuthVerifyYourEmailPage = () => {
	return (
		<PageMeta title="" url={generatePath(PATHS.AUTH.VERIFY_YOUR_EMAIL)}>
			<AuthVerifyYourEmail />
		</PageMeta>
	);
};
